<template>
  <!-- 头部 -->
  <section class="wow animate__animated animate__fadeInLeft">
    <!-- header 电脑端-->
    <div class="header flex f-center hidden-xs-only">
      <el-row class="width100 flex f-center height100">
        <el-col :span="4">
          <img
            class="pointer width100"
            src="../assets/img/logo.png"
            alt=""
            srcset=""
            height="40"
            @click.stop="toPath('/')"
          />
        </el-col>
        <el-col :span="19" :offset="1" class="height100">
          <div class="flex f-between height100">
            <div
              v-for="(item, indexs) in menuData"
              :key="indexs"
              class="c-p first-menu flex1 t-center"
              @click.stop="toPathMenu(item)"
              :class="{ 'is-active': isSelected(item) }"
            >
              {{ item.label }}
              <!-- 二级菜单 -->
              <div class="submenu">
                <div
                  v-for="(item2, index2) in item.children"
                  :key="index2"
                  class=""
                  @click.stop="toPathMenu(item2)"
                >
                  {{ item2.label }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- header 移动端-->
    <div class="header flex f-center hidden-sm-and-up">
      <el-row class="width100 flex f-center height100">
        <el-col :span="12" :push="1">
          <img
            class="pointer"
            src="../assets/img/logo.png"
            alt=""
            srcset=""
            height="30"
            @click="toPath('/')"
          />
        </el-col>
        <el-col :span="12" class="hidden-sm-and-up">
          <div
            class="flex f-end f-center ma-r-20"
            @click="isShowMenu = !isShowMenu"
          >
            <i class="el-icon-menu fon-28"></i>
          </div>
        </el-col>

        <!-- 弹出菜单 -->
        <div class="xs-menu" v-if="isShowMenu">
          <el-menu
            mode="vertical"
            text-color="#333"
            active-text-color="#077CF9"
            :unique-opened="true"
          >
            <div v-for="(item, index) in menuData" :key="index">
              <el-submenu :index="index + ''" v-if="item.children">
                <template slot="title">
                  <div @click="toPathMenu(item)">
                    {{ item.label }}
                  </div>
                </template>
                <el-menu-item
                  :index="index + '-' + index2"
                  v-for="(item2, index2) in item.children"
                  :key="index2"
                  @click="toPathMenu(item2)"
                  >{{ item2.label }}</el-menu-item
                >
              </el-submenu>
              <el-menu-item @click="toPathMenu(item)" v-else>
                <span class="c-333">{{ item.label }}</span>
              </el-menu-item>
            </div>
          </el-menu>
        </div>
      </el-row>
    </div>
  </section>
</template>

<script>
export default {
  name: "Header",
  props: {
    msg: String,
  },
  data() {
    return {
      isShowMenu: false,
      isSubmenu1: false,
      isSubmenu2: false,
      //菜单数据
      menuData: [
        { label: "首页", path: "/" },
        {
          label: "关于我们",
          path: "/about",
          children: [
            { label: "古园风光", path: "" },
            { label: "古园品牌", path: "" },
            { label: "古园荣誉", path: "" },
          ],
        },
        {
          label: "生态节地葬",
          path: "/cemetery",
          children: [
            { label: "成品墓", path: "" },
            { label: "生态节地葬", path: "" },
          ],
        },
        {
          label: "客户服务",
          path: "/customer",
          children: [],
        },
        {
          label: "人文纪念",
          path: "/commemorate",
          children: [],
        },
        {
          label: "古园动态",
          path: "/news",
          children: [],
        },
        {
          label: "服务流程",
          path: "",
          children: [],
        },
        {
          label: "联系我们",
          path: "/contact-us",
        },
      ],
      showSubmenu: [],
      isdeskSubmenu: false,
      activeIndex: 0,
    };
  },
  watch: {},
  created() {
    this.loadCate();
  },
  methods: {
    // 加载动态分类
    loadCate() {
      this.$request({
        url: "/v1/News/Category/Query",
        method: "GET",
      }).then((res) => {
        this.$store.dispatch("setNewsCateList", res);
        let list = [];
        res.map((item) => {
          list.push({ label: item.Name, path: "/news?id=" + item.Id });
        });
        this.menuData.findIndex((item) => {
          if (item.label == "古园动态") {
            item.children = list;
            if(res!=null&&res.length>0){
            item.path="/news?id="+res[0].Id;
            }
          }
        });
      });

      
      this.$request({
        url: "/v1/Cemetery/Category/Query",
        method: "GET",
      }).then((res) => {
        let list = [];
        res.map((item) => {
          list.push({ label: item.Name, path: "/Cemetery?id=" + item.Id });
        });
        this.menuData.findIndex((item) => {
          if (item.label == "生态节地葬") {
            item.children = list;
            if(res!=null&&res.List!=null&&res.List.length>0){
            item.path="/Cemetery?id="+res.List[0].Id;
            }
          }
        });
      });

      this.$request({
        url: "/v1/Service/Service/QueryPage",
        method: "GET",
        params: {
          categoryId: 0,
          pageIndex: 1,
          pageSize: 100,
        },
      }).then((res) => {
        this.$store.dispatch("setServiceCateList", res.List);
        let list = [];
        res.List.map((item) => {
          list.push({ label: item.Title, path: "/service?id=" + item.Id });
        });
        this.menuData.findIndex((item) => {
          if (item.label == "服务流程") {
            item.children = list;
            if(res!=null&&res.List!=null&&res.List.length>0){
            item.path="/service?id="+res.List[0].Id;
            }
          }
        });
      });

      this.$request({
        url: "/v1/Customer/CustomerService/QueryPage",
        method: "GET",
        params: {
          categoryId: 0,
          pageIndex: 1,
          pageSize: 100,
        },
      }).then((res) => {
        this.$store.dispatch("setCustomerCateList", res.List);
        let list = [];
        res.List.map((item) => {
          list.push({
            label: item.Title,
            path: "/customer/detail?id=" + item.Id,
          });
        });
        this.menuData.findIndex((item) => {
          if (item.label == "客户服务") {
            item.children = list;
          }
        });
      });

      this.$request({
        url: "/v1/celebrity/Category/Query",
        method: "GET",
      }).then((res) => {
        this.$store.dispatch("setCommemorateList", res);
        let list = [];
        res.map((item) => {
          list.push({ label: item.Name, path: "/commemorate/list?id=" + item.Id });
        });
        this.menuData.findIndex((item) => {
          if (item.label == "人文纪念") {
            item.children = list;
          }
        });
      });

      this.$request({
        url: "/v1/About/Category/Query",
        method: "GET",
      }).then((res) => {
        this.$store.dispatch("setAboutCateList", res);
        let list = [];
        res.map((item) => {
          list.push({ label: item.Name, path: "/about?id=" + item.Id });
        });
        this.menuData.findIndex((item) => {
          if (item.label == "关于我们") {
            item.children = list;
            if(res!=null&& res.length>0){
            item.path="/about?id="+res[0].Id;
            }
          }
        });
      });

    },

    toPathMenu(item) {
      if (item.path && item.path != this.$route.fullPath) {
        this.$router.push({
          path: item.path,
        });
        this.isShowMenu=false
      }
    },
    //是否为选中的栏目
    isSelected(item) {
      if (item && item.path) {
        return item.path == this.$route.fullPath;
      } else {
        return false;
      }
    },
    toPath(url) {
      if (url && url != this.$route.fullPath) {
        this.$router.push({
          path: url,
        });
      }
    },
  },
  computed: {},
  watch: {
    isShowMenu(newVal) {
      if (newVal) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  height: 80px;
  background-color: #fff;
  position: fixed;
  width: 1280px;
  padding-left: calc(50% - 640px);
  padding-right: calc(50% - 640px);
  z-index: 10;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}

.xs-menu {
  position: fixed;
  top: 80px;
  width: 100%;
  height: calc(100vh - 80px);
  overflow: scroll;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.header-menu {
  border: none !important;
  color: #333;
  height: 100%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #333;
  font-size: 16px;
}

.split-line {
  display: block;
  width: 1px;
  height: 16px;
  background: #e6e8eb;
  margin: 0 20px;
}

.desk-submenu {
  width: 140px;
  background: #ffffff;
  position: absolute;
  left: 50px;
  top: 80px;
  box-sizing: border-box;
  font-size: 14px;
  color: #666;
  padding-bottom: 9px;
}

.desk-submenu > div:first-child {
  border-bottom: 1px solid #e6e8eb;
  padding: 20px;
}

.desk-submenu > div:not(:first-child) {
  padding-bottom: 18px;
}

.desk-submenu > div:hover {
  color: #077cf9;
}

.pa-r-70 {
  padding-right: 70px;
}

.pa-r-50 {
  padding-right: 50px;
}

.pa-r-50 {
  padding-right: 50px;
}

.pa-l-70 {
  padding-left: 70px;
}

.popover-menu {
  border-right: 0px;
}

.popover-menu-item {
  height: 36px;
  line-height: 36px;
}

.popover-iconfont {
  margin-right: 10px;
  font-size: 20px;
  color: #000;
}
.to-alpha-mobile {
  justify-content: right;
}

@media only screen and (max-width: 992px) {
  .header {
    width: 100%;
  }
}
.head-menu-item {
  margin-top: 20px;
  height: 80px;
  cursor: pointer;
}

// 电脑端一级二级菜单样式
.first-menu {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: "background" 0.3s;
  .submenu {
    color: #fff;
    position: absolute;
    width: 100%;
    z-index: 10;
    top: 80px;
    line-height: 40px;
    text-align: center;
    background: #257857;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s;
    font-weight: normal;
    div {
      padding: 5px 0;
    }
  }
  .active-menu {
    max-height: 300px;
  }
}
.first-menu:hover .submenu {
  max-height: 400px;
  background: $--color-primary;
}

.submenu .actives {
  margin-bottom: 0px;
}

.is-active,
.first-menu:hover {
  background: $--color-primary;
  position: relative;
  color: #fff;
  &::after {
    content: "";
    position: absolute;
    background: url("@/assets/img/icon1.png") no-repeat;
    background-size: 100% 100%;
    width: 16px;
    height: 16px;
    left: 50%;
    top: 60px;
    transform: translateY(-50%) translateX(-50%);
  }
  &::before {
    content: "";
    position: absolute;
    background: url("@/assets/img/cloud_mini.png") no-repeat;
    background-size: contain;
    background-position: center;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}
</style>
